import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { ApiWebSocketService } from '@shared';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'pos-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
  styles: [],
})
export class AppComponent implements OnInit {
  private readonly wsService = inject(ApiWebSocketService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    // Reconnect socket after laptop sleep / tab background (same pattern as vendor/user apps).
    fromEvent(document, 'visibilitychange')
      .pipe(
        filter(() => document.visibilityState === 'visible'),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.wsService.resumeFromBackground();
      });
  }
}
